import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnassigned = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.06641 12.834C9.23207 13.1054 9.42807 13.3597 9.65441 13.597C10.3095 14.2914 11.1838 14.739 12.1303 14.8644C13.0767 14.9898 14.0374 14.7853 14.8507 14.2853C15.1549 14.0986 15.4387 13.8692 15.7024 13.597L19.4812 9.66295C21.1496 7.92462 21.1496 5.10828 19.4812 3.36995C19.0926 2.95828 18.6239 2.63032 18.1041 2.40617C17.5842 2.18202 17.024 2.06641 16.4578 2.06641C15.8917 2.06641 15.3315 2.18202 14.8116 2.40617C14.2917 2.63032 13.8231 2.95828 13.4344 3.36995L12.6014 4.23678",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1994 18.5641L9.36761 19.4309C8.97893 19.8428 8.51023 20.1709 7.99023 20.3952C7.47023 20.6194 6.9099 20.7351 6.34361 20.7351C5.77731 20.7351 5.21699 20.6194 4.69699 20.3952C4.17699 20.1709 3.70829 19.8428 3.31961 19.4309C1.65128 17.6926 1.65128 14.8751 3.31961 13.1379L7.09961 9.20394C7.48827 8.79227 7.95691 8.46431 8.4768 8.24016C8.99669 8.01601 9.55687 7.90039 10.123 7.90039C10.6892 7.90039 11.2494 8.01601 11.7693 8.24016C12.2891 8.46431 12.7578 8.79227 13.1464 9.20394C13.3728 9.44116 13.5688 9.69549 13.7344 9.96694",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.9004 16.0671H19.4749M16.0682 21.9004V19.4749M0.900391 6.73372H3.32706M6.73372 0.900391V3.32589",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUnassigned;
